import React from "react";
import { useSelector } from "react-redux";
import FinalStudentSection from "./FinalStudentSection/FinalStudentSection";
import FinalPrepareSection from "./FinalPrepareSection/FinalPrepareSection";
import classes from "./MainSectionsFinalPage.module.css";

const MainSectionsFinalPage = ({ onEnterFinal ,lockBtnWhenChackIsAllowed}) => {

  return (
    <div className={classes.wrapper}>
      <FinalStudentSection onEnterFinal={onEnterFinal} lockBtnWhenChackIsAllowed={lockBtnWhenChackIsAllowed} />
      <FinalPrepareSection />
    </div>
  );
};

export default MainSectionsFinalPage;
